module.exports = __webpack_public_path__ + "img/more4.600b2dcf.png";